import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DEPARTMENT_KEY, IDepartmentState } from '../models/department.model';

const selectFeature = createFeatureSelector<IDepartmentState>(DEPARTMENT_KEY);

export const selectCurrentDepartment = createSelector(
  selectFeature,
  (state: IDepartmentState) => state.department,
);

export const selectCurrentDepartmentDirector = createSelector(
  selectFeature,
  (state: IDepartmentState) => (state.department ? state.department.director : null),
);

export const selectCurrentGroup = createSelector(
  selectFeature,
  (state: IDepartmentState) => state.group,
);

export const selectCurrentGroupDirector = createSelector(
  selectFeature,
  (state: IDepartmentState) => (state.group ? state.group.director : null),
);

export const selectCurrentRegion = createSelector(
  selectFeature,
  (state: IDepartmentState) => state.region,
);

export const selectCurrentRegionDirector = createSelector(
  selectFeature,
  (state: IDepartmentState) => (state.region ? state.region.director : null),
);

export const selectDepartmentListIsLoading = createSelector(
  selectFeature,
  (state: IDepartmentState) => state.isLoading,
);

export const selectAllDepartmentListIsFetched = createSelector(
  selectFeature,
  (state: IDepartmentState) => state.isAllListFetched,
);
export const selectDepartmentsList = createSelector(
  selectFeature,
  (state: IDepartmentState) => state.currentList,
);
